import { IMappingCreateRequest } from "../models/request/mapping/IMappingCreateRequest";
import { apiClient } from "./apiClient";

export const mappingApi = {
    save: (request: IMappingCreateRequest) => apiClient.post(`mapping`, request),
    get: (id: number) => apiClient.get(`mapping/${id}`)
}